import React, { useRef } from 'react';
import { useState, useEffect } from 'preact/hooks';
import { Steps, App } from 'antd';
import { useLocation } from 'react-router-dom';
import { StyledContainer, StyledContainerTitle } from '../../components/container/styled';
import { TextCustom } from '../../components/text';
import { StepFirst } from './view/stepfirst';
import { StepSecond } from './view/stepsecond';
import { StepConfirm } from './view/stepconfirm';
import { ButtonTheme } from '../../components/buttons';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive';
import { useGetOptions } from './hook/useGetOptions';
import { GET, POST, ESTIMATION_PRICE, GET_OPTION_ADDRESS, BOOKING } from '../../services';
import { openAlert } from '../../components/alert/useAlert';
import WrapperComponent from '../../components/hoc/Wrapper-component';
import process1 from '../../assets/icons/process1.svg';
import process2 from '../../assets/icons/process2.svg';
import process3 from '../../assets/icons/process3.svg';
import { StepThird } from './view/stepthird';
import {
  clampBookingDate,
  countEmptyFields,
  mapDetails,
  removeDuplicates,
  mapBookingDetailsOffSite,
  mapBookingDetailsBranch,
} from './functions';
import { ConditionDeliveryModal, ContractModal } from './modal';
import { thaiDate } from './functions';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import 'moment/locale/th';
import dayjs from 'dayjs';
import { color } from '../../resources';
import { postalCodeData, optionOnSiteTime, optionDeliveryTime } from './constant';
import { navigateTo } from '../../utils/navigation';
import { ROUTES_PATH } from '../../resources/routes-name';
import { setGoogleAnalytics } from '../../functions/ga-react';
import { pushDataLayer } from '../../functions/gtm';
import { setFacebookPixel } from '../../functions/fb-react';
import { usePdpa } from '../../hooks/usePdpa';

const HomeScene = () => {
  const { notification, modal } = App.useApp();
  const { control, setValue, getValues, handleSubmit, errors } = useForm();
  const { search } = useLocation();
  const {
    optionsBookingType,
    optionsRegion,
    optionsBattery,
    optionsAccessories,
    optionsWarranty,
    optionsUsedCondition,
    optionsBranch,
    optionsDisplayCondition,
    optionsFrameCondition,
    optionsBackCoverCondition,
    optionsBackCameraConditions,
  } = useGetOptions();

  // PDPA consent management
  const {
    policy,
    consentStatus,
    loading: pdpaLoading,
    error: pdpaError,
    fetchPolicy,
    toggleConsent,
    submitConsentLog,
    isConsentAccepted,
  } = usePdpa();
  const [productName, setProductName] = useState('');
  const [masterPhoneId, setMasterPhoneId] = useState('');
  const [current, setCurrent] = useState(0);
  const [dataStepOne, setDataStepOne] = useState({
    masterPhoneId: '',
    regionId: '',
    batteryId: '',
    accessoryId: '',
    warrantyId: '',
    usedCondition: [],
    displayConditionId: '',
    frameConditionId: '',
    backCoverConditionId: '',
    backCameraConditionId: '',
  });
  const [activeKey, setActiveKey] = useState(['0']);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [productDetail, setProductDetail] = useState([]);
  const [estimationPriceData, setEstimationPriceData] = useState({});
  const [bookingDetail, setBookingDetail] = useState({});
  const [optionProvince, setOptionProvince] = useState([]);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionSubDistrict, setOptionSubDistrict] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [bookingDate, setBookingDate] = useState(dayjs().add(1, 'day').startOf('day'));
  const [bookingTime, setBookingTime] = useState(null);
  const [bookingType, setBookingType] = useState('BOOK-0001');
  const [currentPosition, setCurrentPosition] = useState({ lat: null, lng: null });
  const [mapCenter, setMapCenter] = useState({ lat: 13.7563, lng: 100.5018 });
  const [bookingId, setBookingId] = useState('');
  const [isButtonAddressEnabled, setIsButtonAddressEnabled] = useState(false);
  const [openModalDelivery, setOpenModalDelivery] = useState(false);
  const [openModalContract, setOpenModalContract] = useState(false);
  const [optionTime, setOptionTime] = useState(optionOnSiteTime);
  const [product, setProduct] = useState('');
  const [isEstimating, setIsEstimating] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 767 });
  const styledBtn = {
    color: color.darkgrey,
    backgroundColor: color.yellow,
    borderColor: color.yellow,
    width: !isMobile ? '20%' : '47%',
  };
  const styledStep = { width: '40px', height: '40px' };
  const today = dayjs().startOf('day');
  const sectionRef = useRef(null);
  const sectionContainerTitleRef = useRef(null);

  ///Google Map ///
  const [map, setMap] = useState(null);
  const [autocomplete, setAutocomplete] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(search);
    const model = params.get('model');
    const spec = params.get('spec');
    const masterPhoneId = params.get('masterPhoneId');
    setProductName(`${model} ${spec}`);
    setMasterPhoneId(masterPhoneId);
    setBookingTime(optionTime[0].value);
    setProduct(model);

    if (sectionRef.current) {
      sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // รับค่าพิกัดปัจจุบัน
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        setCurrentPosition({ lat: latitude, lng: longitude });
        setMapCenter({ lat: latitude, lng: longitude });
      },
      (error) => console.error('Error getting current position:', error),
    );
  }, [bookingId, sectionRef]);

  // Fetch PDPA policy on component mount
  useEffect(() => {
    fetchPolicy().catch((err) => {
      console.error('Failed to fetch PDPA policy:', err);
      openAlert({
        type: 'error',
        message: 'ไม่สามารถโหลดนโยบายความเป็นส่วนตัวได้ กรุณารีเฟรชหน้าเว็บ',
      });
    });
  }, []);

  useEffect(() => {
    if (sectionContainerTitleRef.current) {
      requestAnimationFrame(() => {
        const titleBottom =
          sectionContainerTitleRef.current.getBoundingClientRect().bottom + window.scrollY;
        const offset = 100;
        window.scrollTo({
          top: titleBottom - offset,
          behavior: 'smooth',
        });
      });
    }

    const sendEventGoogleAnalytics = async () => {
      const ga = await setGoogleAnalytics();
      const step = [
        'details_condition_of_use',
        'appraisal_price',
        'schedule_date_time_place_sale',
        'confirm_appointment',
      ];
      if (ga) {
        ga.event(`${step[current]}`, {
          category: 'Sell Iphone Flow',
          label: `Sell Iphone ${current + 1} Step`,
        });
        // console.log(step[current])
      }
    };

    const sendEventFacebookPixel = () => {
      const fb = setFacebookPixel();
      const step = [
        'details_condition_of_use',
        'appraisal_price',
        'schedule_date_time_place_sale',
        'confirm_appointment',
      ];
      if (fb) {
        fb.event(`${step[current]}`, {
          category: 'Sell Iphone Flow',
          label: `Sell Iphone ${current + 1} Step`,
        });
        // console.log(step[current])
      }
    };

    sendEventGoogleAnalytics();
    sendEventFacebookPixel();
  }, [current]);

  const onFetchAddress = async (postalCode) => {
    try {
      const { result, success } = await GET(GET_OPTION_ADDRESS(postalCode));
      if (success) {
        const province = result?.optionGetAddress.map((elAddress) => {
          return { value: elAddress.provinceThai, label: elAddress.provinceThai };
        });
        setOptionProvince(removeDuplicates(province));
        setAddressData(result?.optionGetAddress);
      }
    } catch (error) {
      openAlert({
        type: 'error',
        message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      });
    }
  };

  const handleChangeField = (value, item) => {
    switch (item.name) {
      case 'postalCode':
        if (value.target.value.length === 5) {
          if (!postalCodeData.includes(value.target.value)) {
            modal.error({ title: 'เฉพาะกรุงเทพและปริมลฑลเท่านั้น' });
            setValue('postalCode', '');
          } else {
            onFetchAddress(value.target.value);
            setIsButtonAddressEnabled(true);
          }
        } else {
          setIsButtonAddressEnabled(false);
          setOptionDistrict([]);
          setOptionSubDistrict([]);
          setOptionProvince([]);
          setValue('province', '');
          setValue('district', '');
          setValue('subdistrict', '');
        }

        break;
      case 'province':
        const filterProvince = addressData.filter(
          (elProvince) => elProvince.provinceThai === value,
        );
        const district = filterProvince.map((elProvince) => {
          return { value: elProvince.districtThai, label: elProvince.districtThai };
        });
        setOptionDistrict(removeDuplicates(district));
        break;
      case 'district':
        const filterDistrict = addressData.filter(
          (elDistrict) => elDistrict.districtThai === value,
        );
        const subDistrict = filterDistrict.map((elDistrict) => {
          return { value: elDistrict.subDistrictThai, label: elDistrict.subDistrictThai };
        });
        setOptionSubDistrict(removeDuplicates(subDistrict));
        break;
    }
  };

  const handleSelect = (sequence, value) => {
    switch (sequence) {
      case '1':
        setDataStepOne((prevData) => ({ ...prevData, regionId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '2':
        setDataStepOne((prevData) => ({ ...prevData, warrantyId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '3': {
        // ถ้าเป็น FR-000 -> ล็อกขั้นตอนถัดไป + เคลียร์ค่า + เปิดปุ่ม
        if (value === 'FR-000') {
          setDataStepOne((prev) => ({
            ...prev,
            frameConditionId: value,
            // เคลียร์ทุก step ถัดไป
            displayConditionId: undefined,
            backCoverConditionId: undefined,
            backCameraConditionId: undefined,
            batteryId: undefined,
            accessoryId: undefined,
            usedCondition: [],
          }));
          // ไม่ต้อง push activeKey เพิ่ม เพื่อกันผู้ใช้ไล่เปิด step ถัดไป
          setIsButtonEnabled(true);
        } else {
          // เลือกค่าอื่น -> ปลดล็อก flow ปกติ
          setDataStepOne((prev) => ({ ...prev, frameConditionId: value }));
          setActiveKey([...activeKey, sequence]);
        }
        break;
      }

      case '4':
        setDataStepOne((prevData) => ({ ...prevData, displayConditionId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '5':
        setDataStepOne((prevData) => ({ ...prevData, backCoverConditionId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '6':
        setDataStepOne((prevData) => ({ ...prevData, backCameraConditionId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '7':
        setDataStepOne((prevData) => ({ ...prevData, batteryId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '8':
        setDataStepOne((prevData) => ({ ...prevData, accessoryId: value }));
        setActiveKey([...activeKey, sequence]);
        break;

      case '9':
        if (dataStepOne?.usedCondition.includes(value)) {
          setDataStepOne((prevData) => ({
            ...prevData,
            usedCondition: dataStepOne?.usedCondition.filter((item) => item !== value),
          }));
        } else {
          setDataStepOne((prevData) => ({
            ...prevData,
            usedCondition: [...(dataStepOne?.usedCondition || []), value],
          }));
        }
        break;
    }

    // --- สรุปสถานะปุ่ม ---
    // ถ้า frameCondition เป็น FR-000 ให้เปิดปุ่มทันที
    const hardStop =
      sequence === '3' ? value === 'FR-000' : dataStepOne?.frameConditionId === 'FR-000';
    if (hardStop) {
      setIsButtonEnabled(true);
      return;
    }

    // เงื่อนไขเดิม (คงไว้)
    if (
      (dataStepOne?.batteryId === 'BAT-0001' || value === 'BAT-0001') &&
      countEmptyFields(dataStepOne) <= 4
    ) {
      setIsButtonEnabled(true);
    } else {
      setIsButtonEnabled(countEmptyFields(dataStepOne) <= 2);
    }
  };

  const onEstimationPrice = async () => {
    if (isEstimating) return;
    setIsEstimating(true);
    try {
      const payload = { ...dataStepOne, masterPhoneId, product };
      const { result, success } = await POST(ESTIMATION_PRICE, payload);
      if (success) {
        setCurrent(current + 1);
        setProductDetail(mapDetails(result?.detailResult));
        setEstimationPriceData(result?.detailResult);
      }
    } catch (error) {
      openAlert({
        type: 'error',
        message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      });
    }
    setIsEstimating(false);
  };

  const onBookingConfirm = async () => {
    if (!bookingDate) {
      return notification.error({ message: 'กรุณาเลือกวันนัดหมาย' });
    }

    if (!bookingTime) {
      return notification.error({ message: 'กรุณาเลือกเวลานัดหมาย' });
    }

    const {
      street,
      postalCode,
      province,
      district,
      subdistrict,
      branch,
      firstName,
      lastName,
      tel,
      lineId,
      email,
    } = getValues();

    const date = dayjs(new Date(bookingDate)).format('YYYY-MM-DD');
    //const time = dayjs(new Date(bookingTime)).format('HH:mm')
    const bookingTypeText = optionsBookingType.filter((el) => {
      return el.value === bookingType;
    })[0].label;
    const branchText =
      branch &&
      optionsBranch.filter((el) => {
        return el.value === branch;
      })[0].label;
    const selectBranch = {
      bookingType: bookingTypeText,
      branch: branchText,
      bookingDate: thaiDate(date),
      bookingTime,
      firstName,
      lastName,
      tel,
      lineId,
      email,
    };
    const selectOffSite = {
      bookingType: bookingTypeText,
      street,
      currentPosition,
      bookingDate: thaiDate(date),
      bookingTime,
      firstName,
      lastName,
      tel,
      lineId,
      email,
      postalCode,
      province,
      district,
      subdistrict,
    };

    if (bookingDate.isSame(today, 'day')) {
      // await modal.warning({
      //   content: 'หากต้องการขายด่วน รบกวนติดต่อแอดมิน LineOA: @applehouseth (มี@ด้านหน้า)',
      //   // okText: 'โทรติดต่อ',
      //   cancelText: 'ปิด',
      //   style: { fontSize: '20px' },
      //   // onOk() {
      //   //   window.open('tel:0953194700', '_self');
      //   // },
      // });
      setOpenModalContract(true);
    } else {
      if (bookingType === 'BOOK-0001') {
        setBookingDetail(mapBookingDetailsBranch(selectBranch));
      } else if (bookingType === 'BOOK-0002') {
        setBookingDetail(mapBookingDetailsOffSite(selectOffSite));
      }

      // GTM: Confirm Appointment — ยืนยันนัดหมายบนหน้าปฏิทินสำเร็จ (วัน/เวลาครบ ไม่ใช่วันนี้)
      pushDataLayer('confirm_appointment', { booking_type: bookingType });
      setCurrent(current + 1);
    }
  };

  const handleDragEnd = async (event) => {
    const { latLng } = event;
    const lat = latLng.lat();
    const lng = latLng.lng();
    setCurrentPosition({ lat, lng });
  };

  const onLoad = (mapInstance) => {
    setMap(mapInstance);
  };

  const onLoadAutocomplete = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const location = place.geometry.location;
      setCurrentPosition({ lat: location.lat(), lng: location.lng() });
      map.panTo({ lat: location.lat(), lng: location.lng() });
    } else {
      console.log('Autocomplete is not loaded yet!');
    }
  };

  const onSelectDate = (date) => {
    /**
     * dropdown เลือกเดือน/ปีบน header ของ Calendar ยิง onSelect เหมือนการคลิกวันที่
     * จึงต้องบีบให้อยู่ในกรอบ 7 วันตรงนี้ด้วย ไม่ใช่พึ่ง disabledDate อย่างเดียว
     */
    const selected = clampBookingDate(date, bookingType);

    /* นัดที่สาขา : หากทำนัด วันนี้ จะไม่สามารถทำนัดได้ ให้แสดง POP UP */
    if (selected.isSame(today, 'day')) {
      // modal.confirm({
      //   content: `หากต้องการขายด่วน รบกวนติดต่อแอดมิน LineOA: @applehouseth (มี@ด้านหน้า) 55`,
      //   // okText: 'โทรติดต่อ',
      //   cancelText: 'ปิด',
      //   style: { fontSize: '20px' },
      //   // onOk() {
      //   //   window.open('tel:0953194700', '_self');
      //   // },
      // });

      setOpenModalContract(true);
    }

    setBookingDate(selected);
  };

  const toggleCollapse = (key) => {
    setActiveKey(key);
  };

  const onGoBack = () => {
    if (current === 0) {
      window.open('https://applehouseth.com', '_self');
    } else {
      setCurrent(current - 1);
    }
  };

  const onBooking = async () => {
    setIsButtonEnabled(false);
    // GTM: Confirm information — กดปุ่มยืนยันบนหน้าสรุปรายการ (นับตอนกด ไม่รอผล API)
    pushDataLayer('confirm_information', { booking_type: bookingType });

    const {
      street,
      postalCode,
      province,
      district,
      subdistrict,
      branch,
      firstName,
      lastName,
      tel,
      lineId,
      email,
    } = getValues();

    const link =
      (bookingType === 'BOOK-0002' &&
        `https://www.google.com/maps?q=${currentPosition?.lat},${currentPosition?.lng}`) ||
      '';

    try {
      // Generate customerId (UUID v4)
      // Using crypto.randomUUID if available (HTTPS), else use fallback
      let customerId;
      if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        customerId = crypto.randomUUID();
      } else {
        // Fallback UUID v4 generation for non-HTTPS
        customerId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });
      }

      await submitConsentLog(customerId, tel);

      const payload = {
        estimateId: estimationPriceData?.estimateDocument,
        bookType: bookingType,
        firstName,
        lastName,
        tel,
        lineId: lineId || '',
        email: email || '',
        bookingDate: (bookingDate && moment(new Date(bookingDate)).format('YYYY-MM-DD')) || '',
        bookingTime: bookingTime || '',
        branchId: (bookingType === 'BOOK-0001' && branch) || '',
        street: street || '',
        subDistrict: subdistrict || '',
        district: district || '',
        province: province || '',
        postalCode: postalCode || '',
        latitude: (bookingType === 'BOOK-0002' && `${currentPosition?.lat}`) || '',
        longtitude: (bookingType === 'BOOK-0002' && `${currentPosition?.lng}`) || '',
        linkGoogleMap: link.replace('@p0q=', '?q='),
        grade: estimationPriceData?.productGradeFinal,
        baseprice: `${estimationPriceData?.estimateprice ?? ''}`,
        promotion: `${estimationPriceData?.promotion ?? ''}`,
        customerId: customerId,
        // PDPA Consent fields
        pdpaAccepted: consentStatus === 'ACCEPTED',
        consentPolicyVersion: policy?.policyVersion || '',
      };
      const { result, success } = await POST(BOOKING, payload);
      if (success) {
        setBookingId(result?.booking[0].bookingId);
        setIsButtonEnabled(true);

        const thankYouData = {
          bookingId: result?.booking[0].bookingId,
          name: `${firstName} ${lastName}`,
          phone: tel,
          appointmentDate: `${thaiDate(moment(new Date(bookingDate)).format('YYYY-MM-DD'))}`,
          appointmentTime: `${bookingTime ? bookingTime : ''}`,
          appointmentPlace:
            bookingType === 'BOOK-0001'
              ? optionsBranch.find((b) => b.value === branch)?.label || ''
              : `${street}, ${subdistrict}, ${district}, ${province} ${postalCode}`,
          model: productName,
          promotion: estimationPriceData?.promotion,
          price: estimationPriceData?.estimateprice || 0,
          final: estimationPriceData?.finalPrice || 0,
          bookingType: bookingType,
          isThankyou: true,
        };
        sessionStorage.setItem('thankYouData', JSON.stringify(thankYouData));

        navigateTo({
          pathname: ROUTES_PATH.ROUTE_THANKYOU.PATH,
        });
      }
    } catch (error) {
      openAlert({
        type: 'error',
        message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
      });
      setIsButtonEnabled(true);
    }
  };

  const onSelectTime = (time) => {
    setBookingTime(time);
    // let from = 11;
    // let to = 20
    // if (type === 'BOOK-0002') {
    //   from = 10;
    //   to = 18
    // }
    // if (!time || (time.hour() >= from && time.hour() <= to)) {
    //   const selectedTime = time.clone().startOf('minute');
    //   setBookingTime(selectedTime);
    // } else {
    //   modal.error({ title: 'ไม่สามารถเลือกช่วงเวลาทำการได้!' });
    // }
  };

  const onSelectType = (e) => {
    const fieldName = [
      'branch',
      'street',
      'postalCode',
      'province',
      'district',
      'subdistrict',
      'bookingDate',
      'bookingTime',
    ];
    fieldName.forEach((el) => {
      switch (el) {
        case 'street':
        case 'postalCode':
          setValue(el, '');
          break;
        case 'bookingTime':
          setBookingTime(null);
          break;
        case 'bookingDate':
          setBookingDate(dayjs().add(1, 'day').startOf('day'));
          break;
        default:
          setValue(el, null);
          break;
      }
    });

    if (e.target.value === 'BOOK-0002') {
      setOpenModalDelivery(true);
      setOptionTime(optionDeliveryTime);
    } else {
      setOptionTime(optionOnSiteTime);
    }

    setBookingType(e.target.value);
  };

  const items = [
    {
      title: 'รายละเอียดและสภาพการใช้งาน',
      icon: <img src={process1} style={styledStep} />,
      content: (
        <StepFirst
          fn={{ handleSelect, toggleCollapse }}
          data={{ productName, dataStepOne, activeKey }}
          options={{
            region: optionsRegion,
            battery: optionsBattery,
            accessories: optionsAccessories,
            warranty: optionsWarranty,
            usedCondition: optionsUsedCondition,
            displayCondition: optionsDisplayCondition,
            frameCondition: optionsFrameCondition,
            backCoverCondition: optionsBackCoverCondition,
            backCameraConditions: optionsBackCameraConditions,
          }}
        />
      ),
    },
    {
      title: 'สรุปราคาประเมิน',
      icon: <img src={process2} style={styledStep} />,
      content: (
        <StepSecond
          options={{
            booking: optionsBookingType,
            branch: optionsBranch,
            province: optionProvince,
            district: optionDistrict,
            subDistrict: optionSubDistrict,
            optionTime,
          }}
          data={{
            isButtonAddressEnabled,
            detail: productDetail,
            estimation: estimationPriceData,
            bookingDate,
            bookingTime,
            bookingType,
            currentPosition,
            mapCenter,
          }}
          setCurrent={setCurrent}
        />
      ),
    },
    {
      title: 'นัดหมายวันเวลาและสถานที่ขาย',
      icon: null,
      content: (
        <StepThird
          options={{
            booking: optionsBookingType,
            branch: optionsBranch,
            province: optionProvince,
            district: optionDistrict,
            subDistrict: optionSubDistrict,
            optionTime,
          }}
          data={{
            isButtonAddressEnabled,
            bookingDate,
            bookingTime,
            bookingType,
            currentPosition,
            mapCenter,
          }}
          fn={{
            onPlaceChanged,
            onLoadAutocomplete,
            onLoad,
            handleChangeField,
            handleDragEnd,
            onSelectDate,
            onSelectType,
            onSelectTime,
          }}
          forms={{ control, setValue, getValues, handleSubmit, errors }}
          pdpa={{
            policy,
            consentStatus,
            toggleConsent,
            isConsentAccepted,
          }}
        />
      ),
    },
    {
      title: 'ยืนยันนัดหมาย',
      icon: <img src={process3} style={styledStep} />,
      content: (
        <StepConfirm
          data={{
            detail: productDetail,
            booking: bookingDetail,
            estimation: estimationPriceData,
            bookingId,
          }}
        />
      ),
    },
  ];

  const displayItems = items.filter((s) => s.title !== 'นัดหมายวันเวลาและสถานที่ขาย');
  return (
    <div>
      <StyledContainerTitle ref={sectionContainerTitleRef}>
        <TextCustom
          text={'ขายกับ apple sure ง่าย ไว ชัวร์ เพียง 3 ขั้นตอน'}
          size={!isMobile ? '48px' : '38px'}
          color={color.white}
          styled={{ textAlign: 'center' }}
        />
        <Steps
          labelPlacement="vertical"
          current={current > 1 ? current - 1 : current} // ปรับ index ให้ตรงกับ icon
          style={{ marginTop: '30px' }}
          items={displayItems}
        />
      </StyledContainerTitle>
      <StyledContainer>
        <div className="steps-content">{items[current].content}</div>
        <div style={{ marginTop: 24, marginBottom: 60 }}>
          {current === 0 && (
            <div>
              <InfoCircleOutlined className="icon-info" />
              <span className="message-info">
                {
                  'อย่าลืม Reset เครื่อง และลงชื่อออกจาก Apple ID / Google Account ของคุณก่อนทำการขาย เพื่อป้องกันข้อมูลสูญหาย โดยไม่ได้ตั้งใจ'
                }
              </span>
            </div>
          )}
          <div style={{ textAlign: 'right' }}>
            {!bookingId && (
              <ButtonTheme
                useFor="BACK"
                title="ย้อนกลับ"
                onClick={onGoBack}
                disableIcon
                style={{
                  color: '#cfcfcf',
                  backgroundColor: '#fff',
                  borderColor: '#cfcfcf',
                  width: !isMobile ? '20%' : '47%',
                }}
              />
            )}

            {current === 0 && !bookingId && (
              <ButtonTheme
                useFor="CONFIRM"
                title="ประเมินราคา"
                onClick={onEstimationPrice}
                disableIcon
                style={styledBtn}
                disabled={!isButtonEnabled}
                loading={isEstimating}
              />
            )}

            {/* NEW: ขั้นสรุปราคา -> ไปนัดหมาย */}
            {current === 1 && !bookingId && (
              <ButtonTheme
                useFor="CONFIRM"
                title="กดปุ่มเพื่อรับสิทธ์"
                htmlType="button"
                onClick={() => setCurrent(2)}
                disableIcon
                style={styledBtn}
              />
            )}

            {/* นัดหมายวันเวลาและสถานที่ขาย -> ยืนยันรายละเอียดนัด */}
            {current === 2 && !bookingId && (
              <ButtonTheme
                useFor="CONFIRM"
                title="ทำการนัดหมาย"
                onClick={handleSubmit(onBookingConfirm)}
                disableIcon
                style={styledBtn}
              />
            )}

            {/* หน้ายืนยันนัดหมาย -> ยิง Booking */}
            {current === 3 && !bookingId && (
              <ButtonTheme
                useFor="CONFIRM"
                title="ยืนยัน"
                onClick={onBooking}
                disableIcon
                style={styledBtn}
                loading={!isButtonEnabled}
              />
            )}
          </div>
        </div>
      </StyledContainer>
      <ConditionDeliveryModal
        open={openModalDelivery}
        onToggle={() => setOpenModalDelivery(!openModalDelivery)}
      />
      <ContractModal
        open={openModalContract}
        onToggle={() => setOpenModalContract(!openModalContract)}
      />
    </div>
  );
};

export default WrapperComponent('HomeScene')(HomeScene);
